export default __webpack_public_path__ + "static/media/gray2.97e03fd3.png";